import type { IntellectualSubject } from '../stores/intellectualSubjectsStore';

/**
 * Intellectual learning XP (IN3) — a DERIVED view of the learning system,
 * credited to the Intellectual domain. Each Subject's `xp` is the accumulator
 * for its learning-native earners (Learning Sessions + completed Library
 * resources + manual adds, via `addXPToSubject`). Those earners live ONLY in
 * the subject ledger — they never flow through the generic task/habit/project
 * stores — so summing subject XP here is exactly the missing domain credit, with
 * no double-count.
 *
 * This is the SINGLE value `useUserStats` reads to credit the Intellectual
 * domain once (mirroring the Ecological finance pattern). A Path's level still
 * derives from its Subjects (the Overview radar); this rolls the same XP up to
 * the domain.
 *
 * NOTE: tagged actions (a future `subjectId` on tasks/habits/projects, IN3b) are
 * intentionally NOT funneled into `subject.xp` — they already credit the domain
 * through the generic category sum, so keeping them out keeps this credit-once.
 */
export function computeIntellectualLearningXP(subjects: IntellectualSubject[]): number {
  return subjects
    .filter(s => s.is_active)
    .reduce((sum, s) => sum + Math.max(0, s.xp || 0), 0);
}
